$ = window.jQuery;
bds_theme = window.bds_theme;
